import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53c17034"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box-hint" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-title" }, " Hint ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-desc" }, [
  /*#__PURE__*/_createTextVNode(" 페트병이 아닌 플라스틱 용기,"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 비식품용 플라스틱 제품,"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 플라스틱 공병,"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 일회용 플라스틱 컵,"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 모두 수거품목 아닐 걸요~? ")
], -1))
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "footer-btn-group" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "footer-btn-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-hint" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box-title" }, " TIP! "),
  /*#__PURE__*/_createElementVNode("div", { class: "box-desc" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
      /*#__PURE__*/_createTextVNode(" 그거 아세요?"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 플라스틱은 모두 비슷해 보이지만, "),
      /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
      /*#__PURE__*/_createTextVNode(" 사실 재질이 다양해요."),
      /*#__PURE__*/_createElementVNode("br")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
      /*#__PURE__*/_createTextVNode(" 일회용 커피컵은 똑같이 투명하지만 "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 사실은 폴리스틸렌(PS)이나"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 폴리프로필렌(PP)과 같이 재질이 다르거나"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("  음료 페트병의 PET와는 성질이"),
      /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
      /*#__PURE__*/_createTextVNode(" 다른 PET 일 수 있습니다. "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 고품질 자원화를 위해서는 같은 재질,"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 같은 성질의 플라스틱끼리 모여야 해요!"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 페트병이 다시 페트병이 돌아올 수 "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 있도록 투명 음료 페트병만 모아주실거죠? ")
    ])
  ])
], -1))

import Popup from './popup.vue';
import { type ComputedRef, reactive, ref, nextTick, inject } from 'vue';
import _ from 'lodash';


export interface QuizeExpose {
  start: () => void;
}

interface Emits {
  (event: 'success'): void;
}


  const __default__ = {
    inheritAttrs: false
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["success"],
  setup(__props, { expose, emit: emits }: { emit: ({
  (event: 'success'): void;
}), expose: any, slots: any, attrs: any }) {



const images = inject<ComputedRef<Record<string, string>>>('images')!;

const popupVisible = reactive({
  step1: false,
  step2: false,
  stepError: false,
});

function hidePopup(key?: keyof typeof popupVisible) {
  if (key) {
    popupVisible[key] = false;
  } else {
    _.forEach(popupVisible, (val, key) => {
      if (val) {
        popupVisible[key] = false;
      }
    });
  }
}

async function showPopup(key: keyof typeof popupVisible) {
  hidePopup();
  await nextTick();
  popupVisible[key] = true;
}

function start() {
  answer.value = '';
  showPopup('step1');
}

expose<QuizeExpose>({
  start,
});

const answers = [
  {
    // A、PET瓶装水
    name: 'A. 생수 페트병',
    img: images.value['quiz-popup-img-1'],
  },
  {
    // B. 烧酒塑料瓶
    name: 'B. 소주 페트병',
    img: images.value['quiz-popup-img-2'],
  },
  {
    // C. 一次性咖啡杯
    name: 'C. 일회용 커피컵',
    img: images.value['quiz-popup-img-3'],
  },
  {
    // D. 透明饮料塑料瓶
    name: 'D. 투명 음료 페트병',
    img: images.value['quiz-popup-img-4'],
  }
];

// TODO: 确认正确答案
const correctAnswer = answers[2].name;
const answer = ref<string>();
function handleSelectAnswer(item: typeof answers[number]) {
  answer.value = item.name;
}

function handleStep2ButtonClick() {
  if (answer.value) {
    popupVisible.step2 = false;
    if (answer.value === correctAnswer) {
      emits('success');
    } else {
      showPopup('stepError');
    }
  }
}

function handleErrorStepRetry() {
  // 清空答案
  answer.value = '';
  showPopup('step2');
}

const navToPageByKey = inject<(key: 'main' | 'method' | 'mission' | 'date' | 'faq') => void>('navToPageByKey');

function handleErrorStepGuide() {
  hidePopup();
  // 查看指南
  if (navToPageByKey) {
    navToPageByKey('method');
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Popup, {
      modelValue: _unref(popupVisible).step1,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(popupVisible).step1) = $event)),
      title: "깜짝 퀴즈<br>캠페인 참여를 위해 정답을 맞춰야 해요!",
      class: "quiz-modal step-1"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("img", {
          class: "bottle-bottom",
          src: _unref(images)['bottle-135deg-1-line']
        }, null, 8, _hoisted_5),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "footer-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showPopup('step2')))
          }, " 참여 기회 획득하러 가기 ")
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            class: "bottle",
            src: _unref(images)['bottle-45deg']
          }, null, 8, _hoisted_2),
          _hoisted_3,
          _hoisted_4
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(Popup, {
      modelValue: _unref(popupVisible).step2,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(popupVisible).step2) = $event)),
      title: "수거 품목이 아닌 것을 고르세요!",
      class: "quiz-modal step-2"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: _normalizeClass(["footer-btn", { primary: !!answer.value }]),
            onClick: handleStep2ButtonClick
          }, " 정답 제출하기 ", 2)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("ul", null, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(answers, (item) => {
            return _createElementVNode("li", {
              key: item.name,
              class: _normalizeClass({ active: item.name === answer.value }),
              onClick: ($event: any) => (handleSelectAnswer(item))
            }, [
              _createElementVNode("span", null, _toDisplayString(item.name), 1),
              _createElementVNode("img", {
                src: item.img
              }, null, 8, _hoisted_8)
            ], 10, _hoisted_7)
          }), 64))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(Popup, {
      modelValue: _unref(popupVisible).stepError,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(popupVisible).stepError) = $event)),
      title: "정답이 아니에요!<br>포기하지 말고 다시 도전해 볼까요?",
      class: "quiz-modal step-error"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", { class: "footer-btn-group column" }, [
          _createElementVNode("button", {
            class: "footer-btn",
            onClick: handleErrorStepRetry
          }, " 바로 참여권 도전하기 "),
          _createElementVNode("button", {
            class: "footer-btn primary",
            onClick: handleErrorStepGuide
          }, " 수거 가이드 확인하기 ")
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_10
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})